"use client";

import { useContext } from "react";

import { WalletContext } from "@/lib/providers/WalletProvider";

export function useWallet() {
  const wallet = useContext(WalletContext);
  if (!wallet) throw new Error("WalletProvider is required.");
  return wallet;
}
